var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 d-flex justify-content-center align-items-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }